import { FC } from 'react';
import { TextareaProps } from '@mantine/core';

import { useFormComponentContext } from 'context/FormContext';
import useEditStyles from 'hooks/useEditStyles';
import EditableTextField, { Variable } from 'components/EditableTextField';

interface EditableTextProps extends Omit<TextareaProps, 'onChange'> {
  name: string;
  label?: string;
  error?: string;
  value?: string;
  required?: boolean;
  showEdit?: boolean;
  placeholder?: string;
  variables: Variable[];
  onChange?: (value: string) => void;
}

const EditableText: FC<EditableTextProps> = ({
  name,
  label,
  required,
  onChange,
  placeholder,
  variables,
  showEdit = false,
}) => {
  const form = useFormComponentContext();
  const { editedTextStyles } = useEditStyles({ name, showEdit });

  return (
    <EditableTextField
      label={label}
      required={required}
      placeholder={placeholder}
      variables={variables || []}
      style={editedTextStyles}
      {...form.getInputProps(name)}
      onChange={(value) => {
        onChange?.(value);
        form.getInputProps(name).onChange(value);
      }}
    />
  );
};

export default EditableText;
